import * as routeService from "@hub/routes/src/services/route.service"

export default {
  async fetchAndSetSellersOptions({ commit, getters }) {
    try {
      const sellers = await routeService.listSellers()
      const formatedOptions = getters.getFormatedSellersOptions(sellers)
      commit("setSellersOptions", formatedOptions)
    } catch (err) {
      console.error(err)
    }
  },
  async fetchAndSetUsersOptions({ commit, getters }) {
    try {
      const users = await routeService.listUsers()
      const formatedOptions = getters.getFormatedUsersOptions(users)
      commit("setUsersOptions", formatedOptions)
    } catch (err) {
      console.error(err)
    }
  }
}
